import React, { memo } from 'react';

function ShimmerLoader(props) {
  const shimmerLen = props.shimmerLength || 10;
  const shimmers = Array.from(Array(shimmerLen).keys());

  return (
    <div className='shimmer-container'>
      <div className='prod-list'>
        {shimmers.map((_, index) => {
          return (
            <div className='prod-block' key={index}>
              <div className='img-holder shimmer-loader' />
              <div className='prod-desc'>
                <p className='prod-title shimmer-loader' />
                <p className='min-order-qty shimmer-loader' />
                <div className='price shimmer-loader' />
              </div>
              <div className='fake-border' />
            </div>
          );
        })}
      </div>
    </div>
  )
}

export default memo(ShimmerLoader);